// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2WV5e","choiceBoxes":"toolbarselects_choiceBoxes__19XlL","simpleField":"toolbarselects_simpleField__1SfDi"};